/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsExtendTrialRequest
 */
export interface MelcoModelsExtendTrialRequest {
    /**
     * 
     * @type {Date}
     * @memberof MelcoModelsExtendTrialRequest
     */
    new_trial_date?: Date;
}

export function MelcoModelsExtendTrialRequestFromJSON(json: any): MelcoModelsExtendTrialRequest {
    return MelcoModelsExtendTrialRequestFromJSONTyped(json, false);
}

export function MelcoModelsExtendTrialRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsExtendTrialRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'new_trial_date': !exists(json, 'new_trial_date') ? undefined : (new Date(json['new_trial_date'])),
    };
}

export function MelcoModelsExtendTrialRequestToJSON(value?: MelcoModelsExtendTrialRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'new_trial_date': value.new_trial_date === undefined ? undefined : (value.new_trial_date.toISOString()),
    };
}


